export default "__VITE_ASSET__ssMfWIQa__"